import { GrDocumentPdf } from "react-icons/gr";
import { Col, Row } from "../../../../ApiS/Grid-system/Grid-system";
import Title from "../../../Title/Title";
import { RiEditBoxFill } from "react-icons/ri";
import { FaEye, FaRegTrashAlt } from "react-icons/fa";
import Table, { TableOperation } from "../../../Table";
import { usePopUpsStore } from "../../../../store/PopUpStore";
import { useDelete, useFetch, useFilter } from "../../../../ApiS";
import Loader from "../../../Loader";
import Pagination from "../../../pagination/Pagination (1)";
import PopUpDelete from "../../../PopUps/PopUpDelete (1)";
import Search from "../../../Search/Search";
import Add from "../../../Buttons/Add";

interface Curriculums {
  id: number;
  code: string;
  name_en: string;
  name_ar: string;
  min_pass_mark: number;
  theoretical_mark: number;
  practical_mark: number;
  assistances_marks: number;
  type: number;
  is_optional: boolean;
}

export default function SubjectProgram() {
  const { setPopUpDelete, popUpDelete } = usePopUpsStore();
  const { searchParams } = useFilter();
  const page = searchParams.get("page") || 1;

  const in_program = searchParams.get("in_program") || "";
  const { data, isLoading } = useFetch(
    `admin/curriculums?page=${page}&in_program=${in_program}`,
    `admin/curriculums?page=${page}&in_program=${in_program}`
  );
  const { mutation, deleteItem } = useDelete(
    () => window.location.reload(),
    () => console.log(mutation.error)
  );

  const operations: TableOperation[] = [
    {
      name: "show",
      icon: FaEye,
      link: true,
      onClick: () => {
        console.log("View");
      },
    },
    {
      name: "edit",
      icon: RiEditBoxFill,
      link: true,
      onClick: () => {
        console.log("edit");
      },
    },
    {
      name: "delete",
      icon: FaRegTrashAlt,
      link: true,
      onClick: (id) => {
        setPopUpDelete([id, true]);
      },
    },
  ];
  return (
    <>
      <Row>
        <Col lg={4}>
          <Title title="مقررات البرنامج" />
        </Col>
      </Row>
      <Row justify="center">
        <Col lg={11} className="flex justify-center">
          <Search
            placeholder=" في البرنامج "
            className="!w-[80%] border-2 border-[#efc5e6]"
            name="in_program"
          />
        </Col>
      </Row>
      {isLoading && <Loader/>}
      <Row justify="center">
        <Table<Curriculums>
          tableHeads={[
            "رقم المنهاج",
            "رمز المقرر",
            "اسم المقرر بالعربي",
            " اسم المقرر بالانكليزي",

            "العمليات",
          ]}
          tableBody={data?.data?.data}
          keys={["id", "code", "name_en", "name_ar"]}
          operations={operations}
          className="lg:min-w-[100px] md:min-w-[50px]"
        />
      </Row>
      {data?.data?.data?.length > 0 && (
        <Pagination pageCount={data?.data?.last_page} />
      )}

      <PopUpDelete
        text="هل أنت متأكد من حذف هذا المقرر؟"
        onClickDelete={() => {
          deleteItem(`admin/curriculums/${popUpDelete[0]}`);
          mutation.isLoading && <Loader />;
        }}
      />

      <Add link="/curriculums/add" />
    </>
  );
}
